function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMelee = function SvgMelee(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "-123.6 -60.7 210.5 210.5",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    x1: -90.9,
    y1: 117.1,
    x2: -78.5,
    y2: 104.8
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    cx: -102.6,
    cy: 128.9,
    r: 15.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M-34.2,115.9         c-17-18.3-37.1-38.5-55.5-55.5c-4.3-4-10.9-3.8-15,0.3l0,0c-4.1,4.1-4.2,10.7-0.3,15c17,18.3,37.1,38.5,55.5,55.5         c4.3,4,10.9,3.8,15-0.3l0,0C-30.4,126.8-30.2,120.2-34.2,115.9z"
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 15,
      strokeLinecap: "round"
    },
    points: "-71.1,72.3 -60.9,62.1 -75.6,47.5 "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    points: "-21.3,101.8     81.7,-27.4 80.3,-54.1 53.6,-55.5 -75.6,47.5 "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 15,
      strokeLinecap: "round"
    },
    points: "-44.8,98.5 -34.7,88.4 -21.3,101.8 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 15,
      strokeLinecap: "square",
      strokeLinejoin: "round"
    },
    d: "M4,22.2"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    x1: 47.7,
    y1: -21.4,
    x2: -30.1,
    y2: 56.3
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMelee, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/melee.e3fa72aa.svg";
export { ForwardRef as ReactComponent };